export default "__VITE_ASSET__SSL3vBLQ__"